import { useEffect } from "react";
import { NaeSSchemaMap } from "../../config/NaeSSchema";
import { useDataCache } from "./DataCacheProvider";
import { useSelector } from "react-redux";
import { SelectorCountryNae } from "../Models/ormSelectors";

interface ChildId {
  id: number
}

export interface ICountryModelNae {
    id: number,
scopes: any,
badges: any,

}

export const ICountryFieldsNae = [
    "id",
    "scopes",
    "badges"
];

export function useCountryHookNae(id: number) : ICountryModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorCountryNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.Country.schema,
        fields: ICountryFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
